import React, { useMemo } from 'react';
import clsx from 'clsx';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../../../../common/types';
import type { ReelsPlanSettings } from '../../../../../../redux/api/fymAPI.types';
import { reelsPlanMessages } from './reelsPlanMessages';
import { reelsPlanStrip } from './reelsPlanModel';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the AI reels plan; each part uses its own slice of it */
import styles from './ReelsPlan.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface ReelsPlanDayStripProps {
  settings: ReelsPlanSettings;
}

/**
 * The day strip of the setup (design rollout-plan f1, f5): the days of the length, in rows of 14
 * (rows of 7 below 700 px). A filled day gets a reel. A length outside 3 to 60 has no strip.
 */
const ReelsPlanDayStripComponent: React.FC<ReelsPlanDayStripProps> = ({ settings }) => {
  const intl = useIntl();
  const strip = useMemo(() => reelsPlanStrip(settings), [settings]);
  const reels = useMemo(() => strip.filter((day) => day.on).length, [strip]);
  if (strip.length === 0) {
    return null;
  }
  return (
    <div
      className={styles.strip}
      role="img"
      aria-label={intl.formatMessage(reelsPlanMessages.strip, { reels, days: strip.length })}
    >
      {strip.map((day) => (
        <span key={day.date} className={clsx(styles.day, day.on && styles.dayOn)} aria-hidden>
          {day.dayOfMonth}
        </span>
      ))}
    </div>
  );
};

export const ReelsPlanDayStrip = TypedMemo(ReelsPlanDayStripComponent);
